import * as React from "react";
import { FluentProvider, RendererProvider, webLightTheme } from "@fluentui/react-components";
import { FensterDokumentContext } from "./fensterDokument";
import { rendererFuer } from "./hauptRenderer";

const ALS_INHALT: React.CSSProperties = { display: "contents" };

/**
 * Hülle um einen Fensterinhalt: Styles, Fluent-Popups und eigene Portale
 * landen im Dokument `dok` — im Hauptfenster oder im ausgelagerten
 * Browserfenster.
 *
 * Die Hülle ist IMMER da, auch im Hauptfenster; beim Auslagern ändern sich nur
 * ihre Werte. Käme sie erst beim Auslagern dazu, baute React den ganzen
 * Inhalt neu auf — eine halb geschriebene Mail wäre weg. `display: contents`
 * hält sie aus dem Layout heraus.
 */
export const BrowserFensterHuelle: React.FC<{ dok: Document; children: React.ReactNode }> = ({ dok, children }) => (
  <RendererProvider renderer={rendererFuer(dok)} targetDocument={dok}>
    <FluentProvider theme={webLightTheme} targetDocument={dok} style={ALS_INHALT}>
      <FensterDokumentContext.Provider value={dok === document ? null : dok}>{children}</FensterDokumentContext.Provider>
    </FluentProvider>
  </RendererProvider>
);
